<template>
  <div v-if="show" class="item-container">
    <div v-if="hover" class="my-tooltip">
      <h4><strong>Warning</strong></h4>
      <p>Available items is less than the set Reoder level, please order/upload new inventory items </p>
      <div class="item">
        <span>Reorder Level</span>
        <strong>{{reorderLevel}}</strong>
      </div>
      <div class="item">
        <span>Available Items</span>
        <strong>{{availableInventories}}</strong>
      </div>
    </div>
    <button @mouseleave="hover = false" @mouseenter="hover = true" class="buttonStyle">
      <i class="fa fa-warning"></i>
    </button>
  </div>
</template>

<script>
/* eslint-disable */

import { Modal, ModalClose, ModalTitle } from "vuikit/lib/modal";

export default {
  name: "ReorderLevelAlarm",
  props: ["itemRow", "inventories"],
  components: {
    "vk-modal-title": ModalTitle,
    "vk-modal": Modal,
    "vk-modal-close": ModalClose
  },
  data() {
    return {
      show: false,
      openModal: false,
      hover: false,
      reorderLevel: "",
      availableInventories: "",
      ids: []
    };
  },
  methods: {
    collateComponentTypeIds(items) {
      // @todo: if there's a problem, it's definitely here...
      if (items.length > 0 && this.itemRow.id != items[0].componentTypeId) return;
      const componentIds = items
        .map(item => {
          return item.componentTypeId;
        })
        .reduce((total, single) => {
          return {
            ...total,
            [single]: total[single] ? total[single] + 1 : 1
          };
        }, {});
      this.ids = componentIds;
    },
    showWarningElement(rowItem, ids) {
      // console.log(rowItem.reorderLevel, ids)
      // if(parseInt(rowItem.reorderLevel) > )
      const values = Object.values(ids);
      values.forEach(item => {
        if (parseInt(item) <= rowItem.reorderLevel) {
          // yes, show warning
          this.show = true;
          this.availableInventories = item;
          this.reorderLevel = rowItem.reorderLevel
        }
      });
    }
  },
  mounted() {
    this.collateComponentTypeIds(this.inventories);
    this.showWarningElement(this.itemRow, this.ids);
  }
};
</script>

<style lang="scss" scoped>
.buttonStyle {
  background: none;
  border: 0;
  color: #ffb946;
  font-size: 20px;
}
.item-container{
    position: relative;
}
.my-tooltip {
  background: white;
  padding: 10px 20px;
  position: absolute;
  width: 350px;
  color: #555;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
  border-radius: 10px;
  top: -190px;
}
.my-tooltip div{
    padding: 5px 0;
}
.item{
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #ebebeb;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/kitchen/ArnergyInventoryComponents/ReorderLevelAlert.vue